import React from "react";
import "../css/SessionExpiredPopup.css";
import { useLogout } from "../../services/LogoutProvider";
import { Modal } from "@mui/material";

const UnauthorizedPopup = () => {
  const { isUnauthorized, handleUnauthorizedConfirm } = useLogout();

  return (
    <Modal
      className="session-expired-popup white-background"
      style={{backgroundColor: "white"}}
      open={isUnauthorized}
      onOk={handleUnauthorizedConfirm}
    >
      <div className="session-expired-popup-content">
        <h2>Unauthorized Access</h2>
        <p>
          You do not have the required permission to access this application.
        </p>
        <button onClick={handleUnauthorizedConfirm}>Okay</button>
      </div>
    </Modal>
  );
};

export default UnauthorizedPopup;
